import { z } from 'zod';
import { linkCodeSchema } from '../linkCodeConfig.js';

/**
 * Схема `POST /users/ad-source` (work-035 §6, path 2 — реклама ведёт напрямую
 * в мини-апп, `?startapp=a<code>`). Сервер НЕ видит start_param мини-аппа сам
 * (`RecordEventBody`/`CreateBoxBody` — оба `.strict()`, поля нет) — клиент
 * передаёт РАЗОБРАННЫЙ 5-симв. код (без префикса `a`), сервер валидирует
 * существование+`isActive` `AdSource` и решает, писать ли атрибуцию.
 *
 * Response ВСЕГДА `{ ok: true }` — валиден код или нет, существует ли
 * `AdSource` (anti-oracle: иначе `?startapp=aZZZZZ` от кого угодно превращает
 * ручку в детектор существующих кампаний). Несуществующий/неактивный код →
 * сервер тихо игнорирует (не 400, не запись) — DoD work-035 п.4.
 */
export const RecordAdSourceBody = z
  .object({
    code: linkCodeSchema,
  })
  .strict();
export type RecordAdSourceBody = z.infer<typeof RecordAdSourceBody>;

export const RecordAdSourceResponse = z
  .object({
    ok: z.literal(true),
  })
  .strict();
export type RecordAdSourceResponse = z.infer<typeof RecordAdSourceResponse>;
